"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toCamelCase_1 = require("./toCamelCase");
var hexToTransparentRgb_1 = require("./hexToTransparentRgb");
exports.injectStyleProp = function (styleName, defaultValue) {
    return function (props) { return styleName + ": " + (props[toCamelCase_1.toCamelCase(styleName)] || defaultValue) + ";"; };
};
exports.injectStyleColor = function (color, opacity, disabled) {
    if (disabled) {
        return hexToTransparentRgb_1.hexToTransparentRgb(color, opacity);
    }
    else {
        return color.toString();
    }
};
